<script setup>
const props = defineProps({
    // Mostra só o ícone de alerta, para linhas e opções de seletor com pouco espaço.
    icone: {
        type: Boolean,
        default: false,
    },
});

const TEXTO = 'Coordenador Expirado';
const ORIENTACAO = 'Membros com bolsa não podem ser cadastrados nem aprovados até o coordenador ser renovado ou alterado.';
</script>

<template>
    <i v-if="props.icone" class="pi pi-exclamation-triangle text-xs text-yellow-500" role="img" :aria-label="TEXTO"
        v-tooltip.top="`${TEXTO}. ${ORIENTACAO}`" />
    <TagBase v-else :valor="TEXTO" icone="pi-exclamation-triangle" cor="vermelho" negrito
        :tooltip="ORIENTACAO" />
</template>
